import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueMeta from 'vue-meta'

import App from './App.vue'
import VueCookies from 'vue-cookies';
import VueRouter from 'vue-router'


import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'

import aws_exports from '@/aws-exports'

import store from '@/store'

// import Preregister from '@/components/Preregister.vue'
import OauthSignin from '@/pages/OauthSignin.vue'
import OauthSignout from '@/pages/OauthSignout.vue'

import Maintenance from '@/pages/Maintenance.vue'
import LoginCognito from '@/pages/LoginCognito.vue'
import RegisterCognito from '@/pages/RegisterCognito.vue'
// import RegisterVerifyEmail from '@/pages/RegisterVerifyEmail.vue'
import ContinueWith from '@/pages/ContinueWith.vue'
import FinishRegistration from '@/pages/FinishRegistration.vue'

import ForgotPassword from '@/pages/ForgotPassword.vue'
import ChangePassword from '@/pages/ChangePassword.vue'


Amplify.configure(aws_exports);

Vue.config.productionTip = false;

Vue.prototype.$store = store;

Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(VueCookies);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(VueMeta)

const supportedLangs = ["en", "fr"];
const currLang = navigator.language.substring(0, 2);

const i18n = new VueI18n({
  locale: currLang
})

window.locale = navigator.language




// Vue.use(VueGtag, {
//   config: { id: "G-K2FVLQDV6P" }
// });



import DefaultLayout from "@/layouts/Default.vue";
// import PreregisterLayout from "@/layouts/Preregister.vue";
// import PreregisterConfirmationLayout from "@/layouts/PreregisterConfirmation.vue";

Vue.component("default-layout", DefaultLayout);
// Vue.component("pre-register-layout", PreregisterLayout);
// Vue.component("pre-register-confirmation-layout", PreregisterConfirmationLayout);


const routes = [
  
  /* COMMON */
  { path: '*', name : '*-register', component: RegisterCognito },
  { path: '/', name : 'base-register',component: RegisterCognito },
  { path: '/register', name: "register", component: RegisterCognito },
  // { path: '/registerverifyemail', component: RegisterVerifyEmail },
  { path: '/login', name: "login", component: LoginCognito },
  // { path: '/maintenance', name: "login", component: Maintenance },
  
  // { path: '/finish', component: FinishRegistration },
  // { path: '/continue', component: ContinueWith },
  
  // { path: '/oauth-signin', name: 'Social Signin Confirmation', component: OauthSignin },
  // { path: '/oauth-signout', name: 'Social Signout Confirmation', component: OauthSignout },

  /* PASSW */
  { path: '/change-password', name: "change password", component: ChangePassword },
  { path: '/forgot-password', name: "forgot password", component: ForgotPassword },

]
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {

  window.analytics.track

  // window.analytics.page(to.name)
  // window.analytics.track(`pageview-${to.name}`, {
  //   "properties": {
  //     "influencer": "jobiJoba",
  //   },
  //   "event": "PageView - Login"
  // })

  next()

})

new Vue({
  render: h => h(App),
  store,
  router,
  i18n
}).$mount('#app')



document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});